<template>
  <el-dialog
    :title="isEdit ? '编辑配置' : '新增配置'"
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    width="600px"
    @close="handleClose"
    :key="visible"
    custom-class="app-version-config-dialog"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="110px"
    >
      <el-form-item label="版本号" prop="version">
        <el-input
          v-model="formData.version"
          placeholder="请输入版本号，如 2.0.1"
        ></el-input>
      </el-form-item>

      <el-form-item label="图片" prop="image">
        <div class="upload_img_div" v-if="formData.image">
          <img
            style="width: 200px"
            :src="formData.image"
            @click="uploadPicture"
          />
          <div class="upload_img_del">
            <img
              @click="removePicture"
              src="@/assets/images/upload_img_del.png"
            />
          </div>
        </div>
        <div v-else>
          <div class="el-upload__text">
            <img
              style="width: 100px"
              src="@/assets/images/uploadImg.png"
              alt=""
              @click="uploadPicture"
            />
            <br /><em>点击加号上传</em>
          </div>
        </div>
        
        <!-- 剪裁组件弹窗 -->
        <el-dialog
          title=""
          :visible.sync="cropperModel"
          width="1300px"
          center
          :append-to-body="true"
        >
          <template v-if="cropperModel">
            <cropper-image-new
              :Name="cropperName"
              :type="0"
              :showType="0"
              @uploadImgSuccess="handleUploadSuccess"
              ref="child"
            >
            </cropper-image-new>
          </template>
        </el-dialog>
      </el-form-item>

      <el-form-item label="更新说明" prop="description">
        <el-input
          v-model="formData.description"
          placeholder="请输入更新说明"
          type="textarea"
          :rows="5"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CropperImageNew from "@/components/CropperImageNew.vue";

export default {
  name: "AppVersionDialog",
  components: {
    CropperImageNew,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        version: "",
        image: "",
        description: "",
      },
      rules: {
        version: [
          { required: true, message: "版本号不能为空", trigger: "blur" },
        ],
        image: [
          { required: true, message: "图片不能为空", trigger: "blur" },
        ],
        description: [
          { required: true, message: "更新说明不能为空", trigger: "blur" },
        ],
      },
      cropperModel: false,
      cropperName: "",
    };
  },
  watch: {
    visible(newVal) {
      if (newVal && this.isEdit && this.editData.id) {
        this.formData = {
          id: this.editData.id,
          version: this.editData.version,
          image: this.editData.image,
          description: this.editData.description,
        };
      } else if (newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.formData);
        }
      });
    },
    handleClose() {
      this.resetForm();
      this.$emit("update:visible", false);
    },
    resetForm() {
      this.formData = {
        version: "",
        image: "",
        description: "",
      };
      this.cropperModel = false;
      this.$refs.form && this.$refs.form.clearValidate();
    },
    uploadPicture() {
      this.cropperName = this.formData.image || "";
      this.cropperModel = true;
    },
    removePicture() {
      this.formData.image = "";
    },
    handleUploadSuccess(data) {
      this.cropperModel = false;
      this.formData.image = data.url;
    },
  },
};
</script>

<style>
/* 覆盖全局样式，移除 flex 布局 */
.app-version-config-dialog {
  display: block !important;
  justify-content: unset !important;
  text-align: left !important;
}

.app-version-config-dialog .el-dialog__header {
  display: block !important;
  text-align: left !important;
  justify-content: unset !important;
}

.app-version-config-dialog .el-dialog__title {
  display: inline-block !important;
}

.app-version-config-dialog .el-dialog__headerbtn {
  position: absolute !important;
  top: 20px !important;
  right: 20px !important;
}

.app-version-config-dialog .el-dialog__body {
  width: auto !important;
}

/* 图片上传样式 */
.upload_img_div {
  position: relative;
  display: inline-block;
}

.upload_img_div img {
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.upload_img_del {
  position: absolute;
  top: -10px;
  right: -10px;
  cursor: pointer;
}

.upload_img_del img {
  width: 24px;
  height: 24px;
}

.el-upload__text {
  cursor: pointer;
  text-align: center;
}

.el-upload__text em {
  font-style: normal;
  color: #909399;
  font-size: 12px;
}
</style>
